import React, { useState, useEffect, useRef } from "react";
import {
  FaChild,
  FaUser,
  FaShoppingBag,
  FaHeart,
  FaCheck,
  FaChevronDown,
} from "react-icons/fa";
import "./shop.css";
import { useNavigate, useParams } from "react-router-dom";
import { getDatabase, ref, get } from "firebase/database";
import OfferDisplay from "../components/OfferDisplay.js";
import { setPageMeta } from "../utils/seo";
import app from "../firebase/config";

import banatCharcoal2 from "../assets/charcoal .webp";
import miswakImage from "../assets/miswak.webp";
import dinokids from "../assets/dino kids.webp";
import bambosalt from "../assets/Bamboo Salt.webp";
import triaction from "../assets/triaction.webp";
import ufo from "../assets/ufo.webp";
import sweepy from "../assets/sweepy jr.webp";
import multicare from "../assets/whiteness multi care .webp";
import pureSoft from "../assets/sensiplus puresoft.webp";
import whiteness from "../assets/whiteness.webp";
import acrobat from "../assets/acrobat jr.webp";
import puresoft from "../assets/pure soft 2.webp";
import relax from "../assets/whiteness relaxation.webp";
import travelSet from "../assets/travelpack.webp";
import puresoft2 from "../assets/puresoft 1250.webp";

const fallbackImage = whiteness; // Use a local image as fallback

const handleImageError = (e) => {
  e.target.onerror = null;
  e.target.src = fallbackImage;
};

export const allProducts = [
  {
    id: 1,
    name: "TRIACTION TOOBRIGHT 511185",
    price: 160,
    image: whiteness,
    category: "adult",
    type: "whiteness",
    explanation:
      " The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring. Protective cap.",
  },
  {
    id: 2,
    name: "BANAT RELAXION 512152",
    price: 150,
    image: relax,
    category: "adult",
    type: "whiteness",
    explanation:
      "The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring. Protective cap.",
  },
  {
    id: 3,
    name: "BANAT WHITENESS MULTICARE ",
    price: 180,
    image: multicare,
    category: "adult",
    type: "whiteness",
    explanation:
      "The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring. Protective cap.",
  },
  {
    id: 4,
    name: "BANAT TRIACTION TOOFRESH 511412 ",
    price: 160,
    image: triaction,
    category: "adult",
    type: "whiteness",
    explanation:
      "The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring. Protective cap.",
  },
  {
    id: 5,
    name: "PRO 6240 2 PACK 515665",
    price: 250,
    image: puresoft,
    category: "adult",
    type: "pure-soft",
    explanation:
      "The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring. Protective cap.",
  },
  {
    id: 6,
    name: "SENSIPLUS PURESOFT 516266 ",
    price: 150,
    image: pureSoft,
    category: "adult",
    type: "pure-soft",
    explanation:
      "The Tynex Feathered filaments provide the most sensitive and effective cleaning of teeth and gums.",
  },
  {
    id: 7,
    name: "PRO 12540 ULTRASOFT 516181",
    price: 200,
    image: puresoft2,
    category: "adult",
    type: "pure-soft",
    explanation:
      "The PBT bristles with specially rounded tips help prevent the tooth and gums from injuring.",
  },
  {
    id: 8,
    name: "UTRA WHITEBOXED 515825",
    price: 250,
    image: travelSet,
    category: "adult",
    type: "travel",
    explanation:
      "The nylon 6.12 bristles with specially rounded tips prevent the tooth and gums from injuring.",
  },
  {
    id: 9,
    name: "DINO KIDS 511117",
    price: 150, // Set price to 2 rs
    image: dinokids,
    category: "children",
    type: "standard",
    explanation:
      "With its toothbrush head suitable for the mouth structure of kids and straight bristle trim, it helps kids brush their teeth comforbably. Nylon 6.12 bristles with their ends rounded specifically help kids prevent damage on teeth and gingiva.With its handle suitable for hand ergonomy of kids,it helps easy gripping. Designed for 2-5 years old kids with baby teeth with protective cap.",
  },
  {
    id: 10,
    name: "SWEEPY JR",
    price: 120,
    image: sweepy,
    category: "children",
    type: "standard",
    explanation:
      "Ensure effective brushing with its top of the brush for children,thanks to its physiognomy conforming to that of mouth interior.Specially rounded tips of nylon 6.12 bristles donot bruise the teeth surface and gum. With protective cap.",
  },
  {
    id: 11,
    name: "ACROBAT JR",
    price: 200,
    image: acrobat,
    category: "children",
    type: "standard",
    explanation:
      "Ensures effective brushing with its top of the brush for children,to its physiognomy conforming to that of mouth interior.Specially rounded tips of nylon 6.12 bristles donot bruise the teeth surface and gum.Suitable for children who still have at school age secondary teeth together with their first teeth.",
  },
  {
    id: 12,
    name: "UFO 513190",
    price: 150,
    image: ufo,
    category: "children",
    type: "standard",
    explanation:
      " Ensures effective brushing with its top of the brush for children,to its physiognomy conforming to that of mouth interior.Specially rounded tips of nylon 6.12 bristles donot bruise the teeth surface and gum.Your brush stands upright thanks to the vacuumed leg.Suitable for children who still have atschool age secondary teeth together with their first teeth .With protective cap.",
  },
  {
    id: 13,
    name: "BANAT BAMBOO SALT 516198",
    price: 150,
    image: bambosalt,
    category: "essential",
    type: "nature",
    explanation:
      "Special, Thinned Bristle Ends: PBT slimmer tip bristles helps to provide gentle cleaning for sensitive tooth and gums.",
  },
  {
    id: 14,
    name: "BANAT CHARCOAL 514332",
    price: 160,
    image: banatCharcoal2,
    category: "essential",
    type: "nature",
    explanation:
      "PBT Slimmer tip charcoal bristles helps to provide gentle cleaning for sensitive tooth and gums. Protective cover.",
  },
  {
    id: 15,
    name: "BANAT MISWAK 515696",
    price: 150,
    image: miswakImage,
    category: "essential",
    type: "nature",
    explanation:
      "The PBT with specially rounded tips prevent the tooth and gums from injuring . The rubber covered handle prevents slipping and provides an easy and effective brushing.",
  },
];

const Shop = ({
  addToCart = () => {},
  wishlist = [],
  addToWishlist = () => {},
  removeFromWishlist = () => {},
}) => {
  const { category } = useParams();
  const [currentType, setCurrentType] = useState(null);
  const [addedItems, setAddedItems] = useState({});
  const [openDropdown, setOpenDropdown] = useState(null);
  const [uploadedProducts, setUploadedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const hasLoadedRef = useRef(false); // prevent double-load

  const scrollLeft = () => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.firstElementChild ? carouselRef.current.firstElementChild.offsetWidth : 320;
      const gap = 32; // 2rem
      carouselRef.current.scrollBy({ left: -(cardWidth + gap), behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.firstElementChild ? carouselRef.current.firstElementChild.offsetWidth : 320;
      const gap = 32; // 2rem
      carouselRef.current.scrollBy({ left: (cardWidth + gap), behavior: 'smooth' });
    }
  };

  useEffect(() => {
    setPageMeta({
      title: "Shop Toothbrushes | Banat India Store",
      description:
        "Browse Banat India's collection of toothbrushes and oral care essentials with secure checkout.",
      keywords:
        "shop toothbrushes, Banat India store, oral care products, buy toothbrush, dental hygiene",
    });
  }, []);

  // Load uploaded products and website products from Firebase — runs ONCE on mount
  useEffect(() => {
    if (hasLoadedRef.current) return; // prevent re-run
    hasLoadedRef.current = true;

    const loadProducts = async () => {
      try {
        const database = getDatabase(app);
        
        // Load uploaded products
        const imagesRef = ref(database, "productImages");
        const imagesSnapshot = await get(imagesRef);
        
        let uploadedProductsList = [];
        if (imagesSnapshot.exists()) {
          const imagesData = imagesSnapshot.val();
          
          uploadedProductsList = Object.entries(imagesData).map(([id, image]) => {
            const isBlobUrl = image.imageUrl && image.imageUrl.startsWith('blob:');
            return {
              id: parseInt(id.replace('img-', '')) || Date.now(),
              name: image.productName,
              price: image.price || 150,
              discount: image.discount || 0,
              image: isBlobUrl ? fallbackImage : image.imageUrl,
              category: image.category,
              type: image.category,
              explanation: image.description || "Uploaded product",
              isUploaded: true,
              hasInvalidImage: isBlobUrl
            };
          });
        }
        
        // Load website products (edited static products)
        const websiteProductsRef = ref(database, "websiteProducts");
        const websiteProductsSnapshot = await get(websiteProductsRef);
        
        let websiteProductsList = [];
        if (websiteProductsSnapshot.exists()) {
          const websiteProductsData = websiteProductsSnapshot.val();
          websiteProductsList = allProducts.map(originalProduct => {
            const firebaseProduct = websiteProductsData[originalProduct.id];
            if (firebaseProduct) {
              return {
                ...originalProduct,
                name: firebaseProduct.name || originalProduct.name,
                price: firebaseProduct.price || originalProduct.price,
                category: firebaseProduct.category || originalProduct.category,
                type: firebaseProduct.type || originalProduct.type,
                explanation: firebaseProduct.explanation || originalProduct.explanation,
                discount: firebaseProduct.discount || 0
              };
            } else {
              return { ...originalProduct, discount: 0 };
            }
          });
        } else {
          websiteProductsList = allProducts.map(product => ({ ...product, discount: 0 }));
        }
        
        setUploadedProducts([...websiteProductsList, ...uploadedProductsList]);
      } catch {
        // Fallback to static products if Firebase fails (e.g. permission denied for guests)
        setUploadedProducts(allProducts.map(product => ({ ...product, discount: 0 })));
      } finally {
        setLoading(false);
      }
    };

    // Safety timeout — show static products if Firebase takes too long
    const timeoutId = setTimeout(() => {
      setUploadedProducts(prev =>
        prev.length === 0
          ? allProducts.map(product => ({ ...product, discount: 0 }))
          : prev
      );
      setLoading(false);
    }, 3000);

    loadProducts();

    return () => clearTimeout(timeoutId);
  }, []); // ← empty dep array: run ONCE on mount only

  // Use category from URL, default to 'all' if not present
  const currentCategory = category || "all";

  const getFilteredProducts = () => {
    // Use uploadedProducts which now contains both website and uploaded products
    let filtered = uploadedProducts;
    
    // If no products loaded from Firebase, use static products as fallback
    if (filtered.length === 0 && !loading) {
      filtered = allProducts.map(product => ({
        ...product,
        discount: 0
      }));
    }
    
    if (currentCategory !== "all") {
      filtered = filtered.filter((p) => p.category === currentCategory);
    }
    if (currentType) {
      filtered = filtered.filter((p) => p.type === currentType);
    }
    return filtered;
  };

  const handleNavigate = (category, type = null) => {
    setCurrentType(type);
    setOpenDropdown(null); // Close dropdown when navigating
    if (category === "all") {
      navigate("/shop");
    } else {
      navigate(`/shop/${category}`);
    }
  };

  const toggleDropdown = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  const handleWishlistClick = (product) => {
    if (wishlist.find((item) => item.id === product.id)) {
      removeFromWishlist(product.id);
    } else {
      addToWishlist(product);
    }
  };

  const handleAddToCart = (product) => {
    addToCart({ ...product, quantity: 1 });
    setAddedItems((prev) => ({ ...prev, [product.id]: true }));
    setTimeout(() => {
      setAddedItems((prev) => ({ ...prev, [product.id]: false }));
    }, 2000);
  };

  return (
    <div className="shop-container">
      <div className="category-filters">
        <button
          className={`category-btn ${
            currentCategory === "all" ? "active" : ""
          }`}
          onClick={() => handleNavigate("all")}
        >
          <FaShoppingBag className="category-icon" /> All Products
        </button>

        <div className="dropdown">
          <button
            className={`category-btn ${
              currentCategory === "adult" ? "active" : ""
            }`}
            onClick={() => toggleDropdown("adult")}
          >
            <FaUser className="category-icon" /> Adult Toothbrushes{" "}
            <FaChevronDown />
          </button>
          <div className={`dropdown-menu ${openDropdown === "adult" ? "show" : ""}`}>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("adult");
              }}
            >
              All Adult
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("adult", "whiteness");
              }}
            >
              Premium Whiteness
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("adult", "pure-soft");
              }}
            >
              Premium Pure Soft
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("adult", "travel");
              }}
            >
              Travel Sets
            </div>
          </div>
        </div>

        <div className="dropdown">
          <button
            className={`category-btn ${
              currentCategory === "children" ? "active" : ""
            }`}
            onClick={() => toggleDropdown("children")}
          >
            <FaChild className="category-icon" /> Children's Toothbrushes{" "}
            <FaChevronDown />
          </button>
          <div className={`dropdown-menu ${openDropdown === "children" ? "show" : ""}`}>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("children");
              }}
            >
              All Children
            </div>
          </div>
        </div>

        <div className="dropdown">
          <button
            className={`category-btn ${
              currentCategory === "essential" ? "active" : ""
            }`}
            onClick={() => toggleDropdown("essential")}
          >
            <FaUser className="category-icon" /> Essential Toothbrushes{" "}
            <FaChevronDown />
          </button>
          <div className={`dropdown-menu ${openDropdown === "essential" ? "show" : ""}`}>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("essential");
              }}
            >
              All Essential
            </div>
            <div
              onClick={(e) => {
                e.preventDefault();
                handleNavigate("essential", "nature");
              }}
            >
              Premium Nature Category
            </div>
          </div>
        </div>
      </div>

      {loading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading products...</p>
        </div>
      )}
      
      {!loading && getFilteredProducts().length === 0 && (
        <div className="no-products-container">
          <p>No products found. Please try refreshing the page.</p>
          <button 
            onClick={() => window.location.reload()} 
            className="refresh-button"
          >
            Refresh Page
          </button>
        </div>
      )}
      
      {/* Display category-specific offers */}
      {!loading && (
        <div className="category-offers">
          <OfferDisplay category={currentCategory} />
        </div>
      )}
      
      <div className="carousel-container">
        {getFilteredProducts().length > 3 && (
          <button className="carousel-arrow left" onClick={scrollLeft} aria-label="Scroll left">
            &#10094;
          </button>
        )}
        <div className="products-carousel" ref={carouselRef}>
        {getFilteredProducts().map((product, index) => {
          console.log('Rendering product:', product.name, 'Image URL:', product.image);
          return (
            <div 
              className={`product-card enhanced ${product.isUploaded ? 'uploaded-product' : ''}`} 
              key={product.id} 
              tabIndex={0} 
              aria-label={product.name}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {product.isUploaded && (
                <div className="uploaded-badge">NEW</div>
              )}
              {product.hasInvalidImage && (
                <div className="invalid-image-badge">⚠️ INVALID IMAGE</div>
              )}
              <div className="product-image-container">
                <div className="image-skeleton" />
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                  onError={handleImageError}
                  loading="lazy"
                  onClick={() => navigate(`/product/${product.id}`)}
                  style={{
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out'
                  }}
                  onLoad={(e) => {
                    e.target.style.opacity = 1;
                    e.target.previousSibling && (e.target.previousSibling.style.display = 'none');
                  }}
                />
              </div>
            <div className="product-details">
              <h4 className="product-title">{product.name}</h4>
              {product.id && (
                <span className="product-code">#{product.id}</span>
              )}
              <div className="price-section">
                {product.discount && product.discount > 0 ? (
                  <div className="price-with-discount">
                    <span className="original-price">₹{product.price}</span>
                    <span className="discounted-price">₹{Math.round(product.price * (1 - product.discount / 100))}</span>
                    <span className="discount-badge">-{product.discount}%</span>
                  </div>
                ) : (
                  <p className="product-price">₹{product.price}</p>
                )}
              </div>
              <div className="product-actions-row">
                <button
                  className={`add-to-cart-btn enhanced ${addedItems[product.id] ? "added" : ""}`}
                  onClick={() => handleAddToCart(product)}
                  aria-label={addedItems[product.id] ? `Added ${product.name} to cart` : `Add ${product.name} to cart`}
                >
                  {addedItems[product.id] ? (
                    <>
                      <FaCheck className="action-icon" /> ADDED
                    </>
                  ) : (
                    <>
                      <FaShoppingBag className="action-icon" /> ADD
                    </>
                  )}
                </button>
                <button
                  className={`wishlist-btn enhanced${
                    wishlist.find((item) => item.id === product.id)
                      ? " wishlisted"
                      : ""
                  }`}
                  onClick={() => handleWishlistClick(product)}
                  aria-label={
                    wishlist.find((item) => item.id === product.id)
                      ? `Remove ${product.name} from wishlist`
                      : `Add ${product.name} to wishlist`
                  }
                  title={
                    wishlist.find((item) => item.id === product.id)
                      ? "Remove from wishlist"
                      : "Add to wishlist"
                  }
                >
                  <FaHeart className="action-icon heart-icon" />
                  {wishlist.find((item) => item.id === product.id)
                    ? "WISHLISTED"
                    : "WISHLIST"}
                </button>
              </div>
            </div>
          </div>
        );
      })}
        </div>
        {getFilteredProducts().length > 3 && (
          <button className="carousel-arrow right" onClick={scrollRight} aria-label="Scroll right">
            &#10095;
          </button>
        )}
      </div>
    </div>
  );
};

export default Shop;
